import template from './loading-bar.html'

export default {
  template
}
